import React, { useState, useEffect } from "react";
import Select from "react-select";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { getAllListUsers } from "../../../redux/booking/action";
import { addNotificationValidation } from "../../Constant/constant";
import Spinner from "../../Layouts/Spinner";
import { addEmailNotification } from "../../../redux/notification/action";

const PushNotification = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [params, setParams] = useState({
    page: 1,
  });
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectedUser, setSelectedUser] = useState([]);
  const [selectedUserMulti, setSelectedUserMulti] = useState([]);

  const users = useSelector((state) => state.bookingSlice?.getUsersList);

  const options = [
    { value: 1, label: "All Customers" },
    { value: 0, label: "Selected Customer" },
  ];
  const opt = options?.map((item) => ({
    value: item.value,
    label: item.label,
  }));
  const optionUsers = users?.users?.map((item) => ({
    value: item.id,
    label: item.full_name,
  }));

  useEffect(() => {
    dispatch(getAllListUsers(params));
  }, [dispatch, params]);

  const handleChangeName = (selected) => {
    setSelectedOptions(selected);
    formik.setFieldValue("all_customers", selected?.value);
  };

  // const handleChangeUser = (selected) => {
  //   setSelectedUser(selected);
  //   formik.setFieldValue("id", selected?.value);
  // };
  const handleChangeMultiUser = (selected) => {
    setSelectedUserMulti(selected);
    const customerIds = selected.map(option => option.value).join(",");
    console.log(customerIds, "Selected Customer IDs");
    formik.setFieldValue("customer_ids", customerIds);
  };
  

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      subject: "",
      description: "",
      type: 1,
      all_customers: "",
    },
    validationSchema: addNotificationValidation,
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });

  const handleSubmit = async (values) => {
    const data = {
      ...values,
    };
    dispatch(addEmailNotification(data, setLoading));
  };

  console.log(formik.values, "adsfsdfdsfsf");
  return (
    <div>
      <form onSubmit={formik.handleSubmit} className="row">
        <div className=" col-md-4">
          <label>Type</label>
          <Select
            value={selectedOptions}
            onChange={handleChangeName}
            options={opt}
          />
          {formik.touched.all_customers && formik.errors.all_customers ? (
            <div className="error">{formik.errors.all_customers}</div>
          ) : null}
        </div>
        {/* {selectedOptions.value == 0 && (
          <div className=" col-md-4">
            <label>Customer</label>
            <Select
              value={selectedUser}
              onChange={handleChangeUser}
              options={optionUsers}
            />
          </div>
        )} */}
         {selectedOptions.value == 0 && (
          <div className=" col-md-4">
            <label>Multiple Customer</label>
            <Select
            isMulti
              value={selectedUserMulti}
              onChange={handleChangeMultiUser}
              options={optionUsers}
            />
          </div>
        )}
        <div className="col-md-4 form-group">
          <label>Subject</label>
          <input
            type="text"
            className="form-control"
            placeholder="Enter subject"
            name="subject"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.title}
          />
          {formik.touched.subject && formik.errors.subject ? (
            <div className="error">{formik.errors.subject}</div>
          ) : null}
        </div>

        <div className="col-md-12 form-group">
          <label>Description</label>
          <textarea
            className="form-control"
            placeholder="Enter description"
            name="description"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.description}
            rows="3"
          ></textarea>
          {formik.touched.description && formik.errors.description ? (
            <div className="error">{formik.errors.description}</div>
          ) : null}
        </div>
        <div className="col-md-12">
          <button
            style={{ marginLeft: "10px", color: "white" }}
            className="buttons background-button mx-auto d-block"
            disabled={loading}
            type="submit"
          >
            {!loading ? "Submit" : <Spinner />}
          </button>
        </div>
      </form>
    </div>
  );
};

export default PushNotification;
